module.exports = {
      id: "angle-down-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#angle-down",
      toString: function () {
        return this.url;
      }
    }